import React from 'react';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TitleModal } from '../../molecules/modal/TitleModal';
import { appStyles } from '../../../styles';
import { FormPartner } from './forms/FormPartner';
import { PARTNER } from '../../../constants/define/translation';
import { WIDTH_MODAL } from '../../../constants/common';

interface FormPartnerModalProps {
  isOpenModal: boolean;
  onClose: () => void;
  record?: any;
  onRefresh: () => void;
  onReFreshBenefit: () => void;
  onRefreshPartnerAll: () => void;
  setDataRecord: Function;
}

export const FormPartnerModal = (props: FormPartnerModalProps) => {
  const { isOpenModal, onClose, record, onRefresh, onReFreshBenefit, setDataRecord, onRefreshPartnerAll } = props;
  const { t } = useTranslation(PARTNER);
  return (
    <StyledModal
      title={<TitleModal title={record ? t('form.updatePartner') : t('form.createPartner')} />}
      centered
      visible={isOpenModal}
      width={WIDTH_MODAL}
      footer={null}
      onCancel={() => {
        onClose();
        setDataRecord(null);
      }}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
      forceRender
    >
      <FormPartner
        onReFreshBenefit={onReFreshBenefit}
        onRefreshPartnerAll={onRefreshPartnerAll}
        setDataRecord={setDataRecord}
        onCloseModal={onClose}
        onRefresh={onRefresh}
        record={record}
      />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .site-card-wrapper {
    ${appStyles.background.modalBgGray}
    & .card-item {
      text-align: center;
      padding: 1rem;
    }
  }

  & h4.ant-typography {
    ${appStyles.color.black}
  }

  .ant-modal-header {
    padding-left: 0;
  }

  .card-item .ant-image {
    cursor: pointer;
  }

  & .card-up-to-date {
    & .ant-image {
      padding: 0px;
      margin-left: 12px;
      & img {
        width: 92%;
        padding: 5px 0 0px 0;
      }
    }
  }
`;
